import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import { CloseButton, Flex, type FlexProps } from '@/ui';
import { useSettingsModal } from '../store';
import { Navigation } from './Navigation';

export const PanelHeader = ({ children, ...props }: FlexProps) => {
  const close = useSettingsModal((state) => state.close);
  const isMobileBreakpoint = useIsMobileBreakpoint();

  return (
    <Flex
      align="center"
      borderBottomColor="gray.200"
      borderBottomWidth="1px"
      fontSize="lg"
      fontWeight="medium"
      gap="4"
      justify="space-between"
      lineHeight="normal"
      pl="8"
      pr="4"
      py="5"
      {...props}
    >
      {/* Grows so a header that holds a control (e.g. renaming a workspace) can
          use the full width instead of shrinking to its text. */}
      <Flex align="center" flex="1" gap="3" minW="0">
        {isMobileBreakpoint && <Navigation />}
        {children}
      </Flex>
      <CloseButton onClick={close} />
    </Flex>
  );
};
